export default __webpack_public_path__ + "static/media/product.1cc53039.png";